import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Action, RoutePath } from '../../../utils/types';
import { useGlobalDispatch } from '../../../context/GlobalContext';
import { useFormContext } from '../../../context/FormContext';
import { Layout } from '../../common/Layout/Layout';
import { text } from '../../../utils/text';
import { Card } from '../../common/Card/Card';
import { CriticalButton, SecondaryButton } from '@gjensidige/core-buttons';
import { scenarioSteps, trackScenario } from '../../../tracking';
import { getAuthenticationUrl, getCustomerAge } from '../../../utils/utils';
import { PersonvernInfoButton } from '../../common/PersonvernInfoModal/PersonvernInfoButton/PersonvernInfoButton';
import classNames from 'classnames';
import styles from './login-page.module.less';
import { AdditionalInfoAlert } from '../../common/InfoAlert/AdditionalInfoAlert';
export const LoginPage = () => {
    const history = useHistory();
    const globalDispatch = useGlobalDispatch();
    const [{ amountData, customerData }, formDispatch] = useFormContext();
    const params = new URLSearchParams(history.location.search);
    const annuityAmount = params.get('mnd-belop');
    const sellerRef = params.get('ref');
    const isValidAge = getCustomerAge(customerData.ssn) >= 18;
    useEffect(() => {
        if (annuityAmount) {
            formDispatch({
                type: Action.UPDATE_AMOUNT_DATA,
                amountData: Object.assign(Object.assign({}, amountData), { annuity: annuityAmount }),
            });
        }
        if (sellerRef) {
            globalDispatch({
                type: Action.UPDATE_SELLER_REF,
                sellerRef: sellerRef,
            });
        }
        if (customerData.ssn && isValidAge) {
            history.replace(RoutePath.KONTO);
        }
        else {
            trackScenario(scenarioSteps.LOGG_INN_BANKID);
        }
    });
    if (customerData.ssn && !isValidAge) {
        return (React.createElement(Layout, { title: text.LAYOUT.START_SAVING.TITLE.no, subtitle: text.LAYOUT.START_SAVING.SUBTITLE.no },
            React.createElement(Card, { step: 1 },
                React.createElement(AdditionalInfoAlert, { text: text.LOGIN.INVALID_AGE.no }))));
    }
    return (React.createElement(Layout, { title: text.LAYOUT.START_SAVING.TITLE.no, subtitle: text.LAYOUT.START_SAVING.SUBTITLE.no },
        React.createElement(Card, { step: 1, title: text.LOGIN.TITLE.no, subtitle: text.LOGIN.DESCRIPTION.no },
            React.createElement(PersonvernInfoButton, null),
            React.createElement(BankIdButtonGroup, null))));
};
const BankIdButtonGroup = () => {
    const history = useHistory();
    return (React.createElement("div", { className: classNames(styles.authBtnGroup) },
        React.createElement(CriticalButton, { onClick: () => {
                window.location.href = getAuthenticationUrl();
            } }, text.LOGIN.BUTTONS.LOGG_INN.no),
        React.createElement(SecondaryButton, { onClick: () => history.push(RoutePath.KONTO) }, text.LOGIN.BUTTONS.FORTSETT_UTEN.no)));
};
